AgrimarketControllers.controller('loginGrainbowEntraIDController', [
    '$scope', '$location', '$rootScope', 'grainbowService', 'enumFactory', 'configurationFactory', function ($scope, $location, $rootScope, grainbowService, enumFactory, configurationFactory) {

        $scope.logingrainbowErrorMessage = "";
        $rootScope.skin = configurationFactory.Skin;
        $rootScope.loading = true;

        if ($location.protocol().indexOf("https") !== -1) {
            for (var url in configurationFactory.Url) {
                configurationFactory.Url[url] = configurationFactory.Url[url].replace("http:", "https:");
            }
        }

        var host = $location.host();
        var port = $location.port();
        var protocol = $location.protocol();
        var redirectUri =
            protocol + "://" +
            host +
            (host === "localhost" && port ? ":" + port : "") +
            "/loginGrainbowEntraID.html";

        var code = $location.search().code;

        if (!code) {
            $rootScope.loading = false;
            $scope.logingrainbowErrorMessage = "Code d'autorisation manquant. Veuillez recommencer.";
        } else {
            grainbowService.LogGrainbowByEntraID(code, redirectUri, function (dataProfile, statusProfile) {
                $rootScope.loading = false;
                if (statusProfile !== null) {
                    $scope.logingrainbowErrorMessage = (dataProfile && dataProfile[0] && dataProfile[0].errors && dataProfile[0].errors[0]) ? dataProfile[0].errors[0].Message : "Erreur d'authentification";
                } else {
                    $rootScope.AuthorizedGrainbow = true;

                    sessionStorage.setItem("UsersActived", dataProfile.NbUserActived);
                    sessionStorage.setItem("GRAINBOW_TOKEN", dataProfile.GrainbowToken);
                    var allConnections = dataProfile.Connection;
                    var allUsers = [];
                    var allTc = [];
                    var allAdmin = [];

                    dataProfile.User.unshift({
                        "IdUser": 0,
                        "FullName": '------ Sélectionner ------'
                    });

                    if (allConnections !== null)
                        allConnections.unshift({
                            "IdConnection": 0,
                            "FullName": '------ Sélectionner ------'
                        });

                    dataProfile.User.forEach(function (item) {
                        if (item.IdRole === enumFactory.Roles.User || item.IdUser === 0)
                            allUsers.push(item);
                        if (item.IdRole === enumFactory.Roles.TC || item.IdUser === 0)
                            allTc.push(item);
                        if (item.IdRole === enumFactory.Roles.Admin || item.IdUser === 0)
                            allAdmin.push(item);
                    });

                    $rootScope.allUsers = allUsers;
                    $rootScope.allConnections = allConnections;
                    $rootScope.allTc = allTc;
                    $rootScope.allAdmin = allAdmin;
                    $location.path("grainbow/profile");
                }
            });
        }

    }]);
